<template>
  <div class="container">
    <nav class="top-navbar fixed-top text-center">
      <a href="#/" target="_self" class="navbar-brand m-2">
        <img src="/img/svg/expense_guide_logo_inside.svg" alt="expense.guide logo" class="logo-topnav">
      </a>
    </nav>
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Reset Password Request</div>

          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="message" class="alert alert-info">{{ message }}</div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

              <div class="col-md-6">
                <input id="email" v-model="form.email" :class="{ 'is-invalid': errors.email }" type="email" class="form-control" required>
                <span v-if="errors.email" class="invalid-feedback">
                  <div v-for="(error, index) in errors.email" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4">
                <button type="submit" class="btn btn-primary" @click.prevent="submit()">
                  <span v-if="this.$loading.isLoading('sending-password-resetting-request')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Reset Password
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PasswordResetRequest',
  data () {
    return {
      form: {
        email: ''
      },
      message: '',
      error: '',
      errors: {}
    }
  },
  methods: {
    ...mapActions([
      'resetPasswordRequest'
    ]),
    submit () {
      this.$loading.startLoading('sending-password-resetting-request')
      this.errors = {}
      this.resetPasswordRequest(this.form)
        .then((data) => {
          this.error = ''
          this.message = data.message
          this.$loading.endLoading('sending-password-resetting-request')
        })
        .catch((data) => {
          this.message = ''
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('sending-password-resetting-request')
        })
    }
  }
}
</script>
